import { render, staticRenderFns } from "./DashboardLanguageBetaPopup.vue?vue&type=template&id=6494b06e&scoped=true&"
import script from "./DashboardLanguageBetaPopup.vue?vue&type=script&lang=js&"
export * from "./DashboardLanguageBetaPopup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLanguageBetaPopup.vue?vue&type=style&index=0&id=6494b06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494b06e",
  null
  
)

/* custom blocks */
import block0 from "./DashboardLanguageBetaPopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports